import * as moment from "moment";
import { database } from "../firebase";

export const retrieveDeliveries = async (details) => {
  /*
	try{
		const fileList = []
		const allFiles = await database.collection("companies").doc(info.company).collection("library").orderBy("uploadDate").get()
		if(allFiles.size > 0){
			allFiles.forEach((file) => {
				const single = fetchDelivery(file.id, file.data())
				fileList.push(single)
			})
		}
		return Promise.all(fileList).then((result) => {
			return {payload: result, error: null}
		})
	} catch(e) {
		throw({payload: null, error: e})
	}
	*/
};

export const fetchDelivery = (fileId, file) => {
  /*
	return new Promise((resolve, reject) => {
		database.collection("users").doc(file.owner).get().then((user) => {
			if(user.exists){
				const isPassword = (file.password === null)
				resolve({
					key: fileId, 
					downloadLink: isPassword ? file.downloadLink:null, 
					name: file.name, 
					type: file.type, 
					uploadDate: file.uploadDate, 
					password: !isPassword, 
					owner: `${user.data().firstName} ${user.data().lastName}`
				})
			} else {
				reject("error")
			}
		}).catch((e) => {
			reject(e)
		})
	})
	*/
};

export const createNewDelivery = async (details) => {
  try {
    const trimmedObject = details.delivery;

    if (
      trimmedObject &&
      trimmedObject.general &&
      trimmedObject.general.amount
    ) {
      trimmedObject.general.amount = parseInt(
        trimmedObject.general.amount.toString().replace(/ /g, "")
      );
    }

    trimmedObject.dateAdded = moment().unix();

    trimmedObject.lastUpdated = moment().unix();

    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("deliveries")
      .add(trimmedObject);
    return { error: null, payload: null };
  } catch (e) {
    throw new Error(e);
  }
};
